import labels from "app/labels";
import * as ko from "knockout";

export class BackendError extends Error {
  error: string;
  errorDescription: string;

  constructor(error, errorDescription) {
    super(error);
    this.name = error;
    this.error = error;
    this.errorDescription = errorDescription;
  }
}
class HttpErrorHandler {
  //

  processError = (error: any, translate: boolean = true): Error | BackendError => {
    let message: string = "";

    // login errors
    if (error?.responseJSON?.error && error?.responseJSON?.error_description) {
      return new BackendError(error?.responseJSON?.error, error?.responseJSON?.error_description);
    }

    // most backend errors
    message = error?.responseJSON?.ExceptionMessage || error?.message;

    if (!message) {
      message = error?.responseJSON?.Message || error?.message;
    }

    if (JSON.stringify(error) === `{"readyState":0,"status":0,"statusText":"error"}`) {
      message = "cc_P_CONNECTION_REFUSED";
    }

    // backup case
    if (!message) {
      message = ko.toJSON(error);
    }

    if (message && typeof message === "string") {
      // if it needs translation and its a label
      if (message.includes("cc_P_") && translate) {
        message = labels.descr(message);
      }
      return new Error(message);
    }

    return new Error(ko.toJSON(error));
  };
}

export const httpErrorHandler = new HttpErrorHandler();
